<template>
    <div class="template-actions-style ">
  <v-row style="width: 100%" class="ma-0">
    <v-col cols='6'>
            <div class="d-flex flex-column align-center">
              <v-btn class="action-button-style" color="white" @click="$emit('downloadPdf')">
                <v-icon left class="icon-style">mdi-file-pdf</v-icon>
                pdf erzeugen
              </v-btn>
              <v-btn class="action-button-style" color="white" @click="$emit('downloadEmailPreview')"><v-icon left class="icon-style">mdi-email</v-icon>email preview</v-btn>
              <v-btn v-if="selectedTab !== 2" class="action-button-style" color="white" @click="$emit('sendEmail')">
                <v-icon left class="icon-style">mdi-email</v-icon>
               e-mail versand
              </v-btn>
            </div>
    </v-col>
    <v-col cols="6">
      <v-row>
            <div class="d-flex flex-column">
              <v-checkbox value="Eingangsbestätigung_Email"
                          v-model="selectedDocument"
                          label="Eingangsbestätigung Kunde"
                          class="pa-0 ma-0 mt-2"
              />
              <v-checkbox value="Vorlage_Auftragsbestätigung_Email"
                          v-model="selectedDocument"
                          label="Auftragsbestätigung Kunde"
                          class="pa-0 ma-0"
              />
              <v-checkbox value="AuftragseingangSachbearbeiter_Email"
                          v-model="selectedDocument"
                          label="Auftragseingang Sachbearbeiter"
                          class="pa-0 ma-0"
              />
            </div>
      </v-row>
    </v-col>

  </v-row>
    </div>
</template>

<script>

  export default {
    name: "TemplateActions",
    data() {
      return {
        selectedDocument: []
      }
    },
    watch: {
      selectedDocument: function(value) {
        this.$emit('selected', value)
      },
    },
    computed: {
      selectedTab() {
          return this.$store.getters.getSelectedTab;
      }
    }
  }
</script>

<style lang="scss" scoped>

  $main-color: #FFFFFF;

  .action-button-style {
    color: #6E6E6E;
    line-height: 26px;
    text-transform: none !important;
    background: #FFFFFF 0 0 no-repeat padding-box;
    box-shadow: 0 2px 1px #00000029;
    border-radius: 8px;
    opacity: 1;
    margin: 3px;
    width: 197px;
    height: 32px;
    font-size: 18px;
  }

  .icon-style {
    width: 15px;
  }

  .template-actions-style {
    background-color: #F1EFEE;
    margin-top: 1px;
    height: 184px;
    border-radius: 0 0 12px 12px;
    opacity: 0.9;
  }
</style>
